import { render, staticRenderFns } from "./editCat.vue?vue&type=template&id=451889c6&scoped=true"
import script from "./editCat.vue?vue&type=script&lang=js"
export * from "./editCat.vue?vue&type=script&lang=js"
import style0 from "./editCat.vue?vue&type=style&index=0&id=451889c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451889c6",
  null
  
)

export default component.exports